function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useState } from 'react';
import { getSafeId } from '@mantine/utils';
import { useId, useUncontrolled } from '@mantine/hooks';
import { TabsContextProvider } from './Tabs.context.js';
import { TABS_ERRORS } from './Tabs.errors.js';
function TabsProvider(param) {
    var defaultValue = param.defaultValue, value = param.value, onTabChange = param.onTabChange, orientation = param.orientation, children = param.children, loop = param.loop, id = param.id, activateTabWithKeyboard = param.activateTabWithKeyboard, allowTabDeactivation = param.allowTabDeactivation, variant = param.variant, color = param.color, radius = param.radius, inverted = param.inverted, placement = param.placement, _param_keepMounted = param.keepMounted, keepMounted = _param_keepMounted === void 0 ? true : _param_keepMounted, classNames = param.classNames, styles = param.styles, unstyled = param.unstyled;
    var uid = useId(id);
    var _useState = _sliced_to_array(useState([]), 2), mountedPanelIds = _useState[0], setMountedPanelIds = _useState[1];
    var _useUncontrolled = _sliced_to_array(useUncontrolled({
        value: value,
        defaultValue: defaultValue,
        finalValue: null,
        onChange: onTabChange
    }), 2), _value = _useUncontrolled[0], onChange = _useUncontrolled[1];
    return /* @__PURE__ */ React.createElement(TabsContextProvider, {
        value: {
            placement: placement,
            value: _value,
            orientation: orientation,
            id: uid,
            loop: loop,
            activateTabWithKeyboard: activateTabWithKeyboard,
            getTabId: getSafeId("".concat(uid, "-tab"), TABS_ERRORS.value),
            getPanelId: getSafeId("".concat(uid, "-panel"), TABS_ERRORS.value),
            onTabChange: onChange,
            setMountedPanelIds: setMountedPanelIds,
            mountedPanelIds: mountedPanelIds,
            allowTabDeactivation: allowTabDeactivation,
            variant: variant,
            color: color,
            radius: radius,
            inverted: inverted,
            keepMounted: keepMounted,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled
        }
    }, children);
}
TabsProvider.displayName = "@mantine/core/TabsProvider";
export { TabsProvider }; //# sourceMappingURL=TabsProvider.js.map
